import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { stockData, warehouses, commodities } from '../../data/mockData';
import { Filter, Download, QrCode, Lock, RefreshCw, ArrowDown, ArrowUp, Package } from 'lucide-react';
interface StockListProps {
  onInboundClick?: () => void;
  onOutboundClick?: () => void;
  onCommodityClick?: () => void;
}
export function StockList({
  onInboundClick,
  onOutboundClick,
  onCommodityClick
}: StockListProps) {
  const columns = [{
    header: 'Lot ID',
    accessor: (item: any) => <div className="font-mono text-xs font-semibold text-bulog-blue" data-id="element-1141">
          {item.id}
        </div>
  }, {
    header: 'Gudang',
    accessor: 'warehouse',
    className: 'hidden md:table-cell'
  }, {
    header: 'Komoditas',
    accessor: (item: any) => <div className="min-w-0" data-id="element-1142">
          <div className="font-semibold text-gray-900 truncate" data-id="element-1143">
            {item.commodity}
          </div>
          <div className="text-xs text-gray-500 mt-0.5" data-id="element-1144">{item.quality}</div>
        </div>
  }, {
    header: 'Qty (Ton)',
    accessor: (item: any) => <span className="font-semibold text-gray-900" data-id="element-1145">{item.quantity}</span>
  }, {
    header: 'Lokasi',
    accessor: 'location',
    className: 'hidden lg:table-cell'
  }, {
    header: 'Aging',
    accessor: (item: any) => <span className={`font-semibold ${item.aging > 180 ? 'text-red-600' : 'text-gray-900'}`} data-id="element-1146">
          {item.aging} Hari
        </span>,
    className: 'hidden xl:table-cell'
  }, {
    header: 'Status',
    accessor: (item: any) => {
      const variants: any = {
        Available: 'success',
        Allocated: 'warning',
        Blocked: 'danger'
      };
      return <Badge variant={variants[item.status]} data-id="element-1147">{item.status}</Badge>;
    }
  }, {
    header: 'Aksi',
    accessor: () => <div className="flex gap-2" data-id="element-1148">
          <button className="p-2 text-gray-500 hover:text-bulog-blue hover:bg-blue-50 rounded-lg transition-colors" title="Print QR" data-id="element-1149">
            <QrCode size={16} data-id="element-1150" />
          </button>
          <button className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Block Lot" data-id="element-1151">
            <Lock size={16} data-id="element-1152" />
          </button>
        </div>,
    className: 'hidden sm:table-cell'
  }];
  return <div className="space-y-6" data-id="element-1153">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4" data-id="element-1154">
        <div data-id="element-1155">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1156">Stok Gudang</h1>
          <p className="text-gray-500 mt-1" data-id="element-1157">
            Monitoring stok nasional per lot/batch
          </p>
        </div>
        <div className="flex flex-wrap gap-2 w-full lg:w-auto" data-id="element-1158">
          <Button variant="secondary" onClick={onCommodityClick} icon={<Package size={16} data-id="element-1160" />} className="flex-1 sm:flex-none" data-id="element-1159">
            Lihat Komoditas
          </Button>
          <Button variant="outline" onClick={onInboundClick} icon={<ArrowDown size={16} data-id="element-1162" />} className="flex-1 sm:flex-none" data-id="element-1161">
            Terima Barang
          </Button>
          <Button variant="outline" onClick={onOutboundClick} icon={<ArrowUp size={16} data-id="element-1164" />} className="flex-1 sm:flex-none" data-id="element-1163">
            Order Keluar
          </Button>
          <Button icon={<RefreshCw size={16} data-id="element-1166" />} className="flex-1 sm:flex-none" data-id="element-1165">
            Stock Opname
          </Button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1167">
        <Card className="border-l-4 border-l-bulog-blue" data-id="element-1168">
          <div data-id="element-1169">
            <p className="text-sm text-gray-500 mb-1" data-id="element-1170">Total Komoditas</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1171">
              {commodities.length}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1172">Jenis pangan</p>
          </div>
        </Card>
        <Card className="border-l-4 border-l-green-500" data-id="element-1173">
          <div data-id="element-1174">
            <p className="text-sm text-gray-500 mb-1" data-id="element-1175">Total Lot</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1176">
              {stockData.length}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1177">Batch tersimpan</p>
          </div>
        </Card>
        <Card className="border-l-4 border-l-bulog-orange" data-id="element-1178">
          <div data-id="element-1179">
            <p className="text-sm text-gray-500 mb-1" data-id="element-1180">Available</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1181">
              {stockData.filter(s => s.status === 'Available').length}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1182">Siap distribusi</p>
          </div>
        </Card>
        <Card className="border-l-4 border-l-red-500" data-id="element-1183">
          <div data-id="element-1184">
            <p className="text-sm text-gray-500 mb-1" data-id="element-1185">Blocked</p>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1186">
              {stockData.filter(s => s.status === 'Blocked').length}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1187">Quality hold</p>
          </div>
        </Card>
      </div>

      <Card data-id="element-1188">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-1189">
          <Select label="Gudang" options={[{
          value: 'all',
          label: 'Semua Gudang'
        }, ...warehouses.map(w => ({
          value: w,
          label: w
        }))]} data-id="element-1190" />
          <Select label="Komoditas" options={[{
          value: 'all',
          label: 'Semua Komoditas'
        }, ...commodities.map(c => ({
          value: c,
          label: c
        }))]} data-id="element-1191" />
          <Select label="Status Mutu" options={[{
          value: 'all',
          label: 'Semua Status'
        }, {
          value: 'available',
          label: 'Available'
        }, {
          value: 'blocked',
          label: 'Blocked (QC Hold)'
        }]} data-id="element-1192" />
          <div className="flex items-end" data-id="element-1193">
            <Button variant="secondary" className="w-full" icon={<Filter size={16} data-id="element-1195" />} data-id="element-1194">
              Terapkan Filter
            </Button>
          </div>
        </div>

        <Table data={stockData} columns={columns} keyExtractor={item => item.id} data-id="element-1196" />
      </Card>
    </div>;
}